import * as React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { ProLayout, DefaultFooter, MenuDataItem} from '@ant-design/pro-components';
import { RightContent, ErrorBoundary } from '@/components';
import menu from '@/config/menu';
import PageContent from '../PageContent';

const loopMenuItem = (menus: MenuDataItem[]): MenuDataItem[] =>
  menus.map(({ children, ...item }) => ({
    ...item,
    key: item.name,
    children: children && loopMenuItem(children),
  }));
const newMenu = loopMenuItem(menu);

const PageLayout: React.FC<any> = observer(() => {
  const location = useLocation();
  const [settings] = React.useState({
    navTheme: 'light',
    layout: "mix",
    contentWidth: "Fluid",
    headerHeight: 48,
    splitMenus: false,
    fixSiderbar: false,
    fixedHeader: false
  });

  return (
    <div style={{ height: '100vh' }} id="app-pro-layout">
      {/* @ts-ignore */}
      <ProLayout
        title={false}
        logo={
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/logo.svg`} alt="logo"
            style={{ height: 'auto' }}
          />
        }
        location={location}
        route={{
          routes: newMenu
        }}
        menuItemRender={(item: any, dom: any) => (
          <Link to={item.path}>{dom}</Link>
        )}
        rightContentRender={() => <RightContent />}
        footerRender={() => (
          <DefaultFooter
            copyright="Copyright WINIT CORPORATION. All Rights Reserved"
          />
        )}
        ErrorBoundary={ErrorBoundary}
        {...settings}
      >
        <PageContent>
          <Outlet />
        </PageContent>
      </ProLayout>
    </div>
  );
});

export default PageLayout;
